module.exports = __webpack_public_path__ + "static/media/complex_average_power_summary.85d4ca1e.svg";